import React from 'react'
import PropTypes from 'prop-types'
import { useModal } from './Modal'

export default function ModalFooter({ children }) {
  const modalContext = useModal()

  if (!modalContext) return null
  return <div className="modal-lite__content-footer">{children}</div>
}

ModalFooter.propTypes = {
  children: PropTypes.node
}
